export default "__VITE_ASSET__a3de0b55__"